
import { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import PublicRoutes from './_config/publicRoutes';
import PrivateRoutes from './_config/privateRoutes';
import { URLS } from './_config';
import AOS from 'aos';
import 'aos/dist/aos.css';
import './App.scss';
import Page404 from './pages/404';
import Home from './pages/home';
import Login from './pages/auth/login';
import Registration from './pages/auth/registration';
import ForgotPassword from './pages/auth/forgotPassword';
import ResetPassword from './pages/auth/resetPassword';
import Processors from './pages/processors';
import Profile from './pages/profile';
import Mylos from './pages/mylos';


import RequestResolution from './pages/request_resolution/RequestResolution';
import FundingRequest from './pages/funding_request/FundingRequest';
import Submitfile from './pages/submitfile';
import FundingRequestList from './pages/funding_request/FundingRequestList';
import Lender from './pages/lender';
import ScenarioCoaches from './pages/scenarioCoaches';
import Vendors from './pages/vendors';
import Shop from './pages/shop/Shop';
import PreOrder from './pages/preorder/PreOrder';
import FundingOverview from './pages/funding_overview/FundingOverview';
import ProfileDetails from './pages/profile_details';
import RegisterModal from './pages/auth_verification/register_modal';
import EmployeeReview from './pages/employee/EmployeeReview';



function App() {

	useEffect(() => {
		AOS.init({
		  duration: 500, // Animation duration in milliseconds
		});
	  }, []);


	return (
		<Router>

			<div className="App">
				<Routes>
					<Route element={<PublicRoutes />}>
						<Route path={URLS.LOGIN} element={<Login />}></Route>
						<Route path={URLS.REGISTER} element={<Registration />}></Route>
						<Route path={URLS.FORGOT_PASSWORD} element={<ForgotPassword />}></Route>
						<Route path={URLS.RESET_PASSWORD} element={<ResetPassword />}></Route>
					</Route>

					{/* <Route path={URLS.RESET_PASSWORD} element={<ResetPassword />}></Route> */}

					<Route element={<PrivateRoutes />}>
						<Route path={URLS.USER_VERIFICATION} element={<RegisterModal />}></Route>
						<Route path={URLS.HOME} element={<Home />}></Route>
						<Route path={URLS.PROFILE} element={<Profile />}></Route>
						<Route path={URLS.PROFILEDETAILS} element={<ProfileDetails />}></Route>
						<Route path={URLS.EMPLOYEEREVIEW} element={<EmployeeReview />}></Route>

						<Route path={URLS.MYLOS} element={<Mylos />}></Route>

						<Route path={URLS.PROCESSORS} element={<Processors />}></Route>
						<Route path={URLS.LENDER} element={<Lender />}></Route>
						<Route path={URLS.SCENARIO_COACHES} element={<ScenarioCoaches />}></Route>
						<Route path={URLS.VENDORS} element={<Vendors />}></Route>
						
						<Route path={URLS.ESCALATION.LIST} element={<RequestResolution />}></Route>
						<Route path={URLS.PREORDER.LIST} element={<PreOrder />}></Route>

						<Route path={URLS.FUNDING.REQUEST_LIST} element={<FundingRequestList />}></Route>
						<Route path={URLS.FUNDING.SUBMIT_REQUEST} element={<FundingRequest />}></Route>
						<Route path={URLS.FUNDINGOVERVIEW.LIST} element={<FundingOverview />}></Route>

						<Route path={URLS.SHOP} element={<Shop />}></Route>

						<Route path={URLS.SUBMITFILE} element={<Submitfile />}></Route>

					</Route>

					<Route path={`*`} element={<Page404 />}></Route>
				</Routes>
			</div>
		</Router>
	);
}

export default App;
